import { ConstructPhoneNumber } from '@/helpers';
import { PhoneNumber } from '@/@types/member';
import { Phone } from '@/filters';

export default (phone: PhoneNumber): string => {
  return Phone(ConstructPhoneNumber(phone));
};
